export default __webpack_public_path__ + "static/media/QuATRo_Siegel_2021_Gruen.64747468.svg";